const absoluteUrlPattern = /^(?:[a-z]+:)?\/\//i
const storagePathPattern = /^\/?storage\/(?:image|fileaccess)\/.+/i

const trimTrailingSlash = (value = "") => value.replace(/\/+$/, "")

const getStorageOrigin = () => {
  const storageBaseUrl =
    process.env.REACT_APP_API_STORAGE_URL ||
    "https://api.nobatoon.ir/storage"

  try {
    return new URL(storageBaseUrl).origin
  } catch (err) {
    return trimTrailingSlash(storageBaseUrl).replace(/\/storage$/, "")
  }
}

export const resolveStorageUrl = (value) => {
  if (typeof value !== "string" || !value) return value
  if (absoluteUrlPattern.test(value)) return value
  if (!storagePathPattern.test(value)) return value

  const normalizedPath = value.startsWith("/") ? value : `/${value}`

  return `${getStorageOrigin()}${normalizedPath}`
}

export const toStoragePath = (value) => {
  if (typeof value !== "string" || !value) return value

  try {
    const parsedUrl = new URL(value)
    const path = `${parsedUrl.pathname}${parsedUrl.search}`

    if (storagePathPattern.test(path)) {
      return path
    }
  } catch (err) {
    if (storagePathPattern.test(value)) {
      return value.startsWith("/") ? value : `/${value}`
    }
  }

  return value
}

export const normalizeStoragePayload = (value) => {
  if (typeof value === "string") {
    return resolveStorageUrl(value)
  }

  if (Array.isArray(value)) {
    return value.map(normalizeStoragePayload)
  }

  if (value && typeof value === "object") {
    return Object.keys(value).reduce((acc, key) => {
      acc[key] = normalizeStoragePayload(value[key])
      return acc
    }, {})
  }

  return value
}
